// Top-level identity linker. Runs as soon as the user is authenticated and
// a visitor_id exists in localStorage, independent of which page mounted.
// Dedupes per (user_id + visitor_id + session) using sessionStorage.
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function IdentityLinker() {
  useEffect(() => {
    let cancelled = false;

    const linkOnce = async (userId: string) => {
      try {
        const visitorId =
          typeof window !== "undefined"
            ? localStorage.getItem("ap_visitor_id")
            : null;
        if (!visitorId) return;
        const key = `ap_identity_linked:${userId}:${visitorId}`;
        if (sessionStorage.getItem(key)) return;
        sessionStorage.setItem(key, "1");
        await supabase.functions
          .invoke("identity-link", {
            body: { visitor_id: visitorId, source: "web_app" },
          })
          .catch(() => {
            // best-effort; clear the flag so we retry next session
            sessionStorage.removeItem(key);
          });
      } catch {
        /* ignore */
      }
    };

    // Run on initial mount if a session already exists
    void supabase.auth.getSession().then(({ data }) => {
      if (cancelled) return;
      const uid = data.session?.user?.id;
      if (uid) void linkOnce(uid);
    });

    // Run on subsequent SIGNED_IN events
    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN" && session?.user?.id) {
        void linkOnce(session.user.id);
      }
    });

    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, []);

  return null;
}
